// FiltrosInformes.jsx
import React, { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { Button, Select_simple, Input } from './ui';

//importamos el componente InfoButtonWithPopover
import InfoButtonWithPopover from "./InfoButtonWithPopover";

import { optionsObjeto_Tramitacion_Pagos, optionsDocumentacionPresentada, optionsEtapaPago, 
    optionsEncargadoProyecto, optionsPartido, optionsAreaResponsable, optionsTipoSubsidio, optionsPrograma, optionsEstado, 
    optionsCategoria,
    optionsProgramaUNO, optionsProgramaDOS, optionsProgramaTRES, optionsProgramaCUATRO, optionsProgramaCINCO } from '../datos/options';

import { AREA_RESP_OBRAS, AREA_RESP_MEJORAS, AREA_RESP_MICROCREDITOS, AREA_RESP_INTERVENCION_SOCIAL, AREA_RESP_OTRA } from '../constants/config';

// Años y gestiones: mismo patrón que Tableros e Informe de Organizaciones.
const ALL_YEARS = ['2027','2026','2025','2024','2023','2022','2021','2020','2019','2018','2017','2016'];
const GESTIONES = [
    { key: '2da', label: '2da Gestión (2024–2027)', years: ['2027','2026','2025','2024'] },
    { key: '1era', label: '1era Gestión (2020–2023)', years: ['2023','2022','2021','2020'] },
];
const yearOptions = ALL_YEARS.map((y) => ({ value: y, label: y }));
const gestionOptions = GESTIONES.map((g) => ({ value: g.key, label: g.label }));
const CRITERIOS_ANIO = [
    { value: 'pago_anticipo', label: 'Pago (anticipo o total)' },
    { value: 'expediente', label: 'Actual (por año exp. de proyecto)' },
];

// 2. CONSTANTES LOCALES (Fuera del componente para que no se re-creen al renderizar)
const PROGRAM_OPTIONS_MAP = {
    [AREA_RESP_OBRAS]: optionsProgramaUNO, // por ahora hardcodear
    [AREA_RESP_MEJORAS]: optionsProgramaDOS,
    [AREA_RESP_MICROCREDITOS]: optionsProgramaTRES,
    [AREA_RESP_INTERVENCION_SOCIAL]: optionsProgramaCUATRO,
    [AREA_RESP_OTRA]: optionsProgramaCINCO
};


const FiltrosInformes = ({ data, datosFiltrados, filters, onFilterChange, limpiarFiltros }) => { //datosFiltrados

    console.log("DATA --->", data)
    console.log("datosFiltrados", datosFiltrados)

    const [partidosUnicos, setPartidosUnicos] = useState([]); //para partido_nombre
    const [organismosSolicitanteUnicos, setOrganismosSolicitanteUnicos] = useState([]); //para organismo_solicitante    

    // 1. función genérica
    const getUniqueAndFormattedItems = (data, propertyName) => {
        // Extrae y filtra los valores no vacíos o nulos
        const filteredItems = data
            .map(item => item[propertyName])
            .filter(item => item && item !== '');

        // Crea un Set con los valores únicos
        const uniqueItems = new Set(filteredItems);

        // Convierte el Set a un array y formatea los objetos
        return Array.from(uniqueItems).map(item => ({
            value: item,
            label: item
        }));
    };

    // 2. Agrupa los organismos solicitantes por tipo de subsidio, para que el
    // select muestre juntos los Municipios, las ONGs y las Universidades.
    const getOrganismosAgrupados = (data) => {
        // Una cabecera por tipo de subsidio (el orden define el orden de los grupos)
        const GRUPOS = [
            { label: 'Municipios', tipo: 'Subsidio a municipio' },
            { label: 'ONGs', tipo: 'Subsidio a ONG' },
            { label: 'Universidades', tipo: 'Subsidio a Universidades' },
        ];
        // El tipo de subsidio viene con distinta capitalización ("Municipio" / "municipio")
        const norm = (valor) => (valor || '').trim().toLowerCase();

        // organismo -> tipo de subsidio (un organismo tiene un solo tipo)
        const tipoPorOrganismo = new Map();
        data.forEach(item => {
            const organismo = item.organismo_solicitante;
            if (!organismo || !organismo.trim()) return;
            if (!tipoPorOrganismo.has(organismo)) {
                tipoPorOrganismo.set(organismo, item.tipo_subsidio || '');
            }
        });

        const aOpciones = (organismos) => organismos
            .sort((a, b) => a.trim().localeCompare(b.trim()))
            .map(organismo => ({ value: organismo, label: organismo }));

        const grupos = GRUPOS.map(({ label, tipo }) => ({
            label,
            options: aOpciones(
                Array.from(tipoPorOrganismo.entries())
                    .filter(([, t]) => norm(t) === norm(tipo))
                    .map(([organismo]) => organismo)
            ),
        }));

        // Organismos con un tipo de subsidio que no está en la lista fija
        const tiposConocidos = GRUPOS.map(g => norm(g.tipo));
        const otros = Array.from(tipoPorOrganismo.entries())
            .filter(([, t]) => !tiposConocidos.includes(norm(t)))
            .map(([organismo]) => organismo);
        if (otros.length) grupos.push({ label: 'Otros', options: aOpciones(otros) });

        return grupos.filter(g => g.options.length > 0);
    };

    // 3. Unifica los efectos en un solo useEffect
    useEffect(() => {
        // Obtén y actualiza los partidos únicos
        const partidosUnicos = getUniqueAndFormattedItems(data, 'partido_nombre');//NO SE USA, usar optionsPartido
        setPartidosUnicos(partidosUnicos);

        // Obtén y actualiza los organismos solicitante, agrupados por tipo de subsidio
        setOrganismosSolicitanteUnicos(getOrganismosAgrupados(datosFiltrados)); //quitar datosFiltrados, usamos data

    }, [data, datosFiltrados]); // El efecto se ejecuta solo cuando 'data' cambia //datosFiltrados

    // 3. Tipos únicos según el área responsable seleccionada (derivados de la data)
    const tiposUnicos = React.useMemo(() => {
        const base = filters.area_responsable
            ? data.filter(item => item.area_responsable && item.area_responsable.includes(filters.area_responsable))
            : data;
        const tiposSet = new Set();
        base.forEach(item => {
            (item.array_tipo_subtipo_proyecto || []).forEach(ts => {
                if (ts.tipo) tiposSet.add(ts.tipo);
            });
        });
        return Array.from(tiposSet).map(t => ({ value: t, label: t }));
    }, [data, filters.area_responsable]);

    // 4. Subtipos únicos según el tipo seleccionado (derivados de la data)
    const subtiposUnicos = React.useMemo(() => {
        if (!filters.tipo) return [];
        const base = filters.area_responsable
            ? data.filter(item => item.area_responsable && item.area_responsable.includes(filters.area_responsable))
            : data;
        const subtiposSet = new Set();
        base.forEach(item => {
            (item.array_tipo_subtipo_proyecto || []).forEach(ts => {
                if (ts.tipo === filters.tipo && ts.subtipo) subtiposSet.add(ts.subtipo);
            });
        });
        return Array.from(subtiposSet).map(s => ({ value: s, label: s }));
    }, [data, filters.area_responsable, filters.tipo]);

    // Estilos de react-select para que el buscador de Municipio / ONGs
    // se vea igual que los Select_simple de al lado (h-10, borde gris, dark mode).
    const customSelectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: '40px',
            borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
            borderWidth: '1px',
            borderRadius: '0.375rem',
            boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
            '&:hover': { borderColor: state.isFocused ? '#3b82f6' : '#9ca3af' },
            backgroundColor: document.documentElement.classList.contains('dark') ? '#1f2937' : '#ffffff',
        }),
        menu: (base) => ({
            ...base,
            borderRadius: '0.375rem',
            border: '1px solid #d1d5db',
            backgroundColor: document.documentElement.classList.contains('dark') ? '#1f2937' : '#ffffff',
        }),
        option: (base, state) => ({
            ...base,
            fontSize: '0.875rem',
            backgroundColor: state.isSelected
                ? '#3b82f6'
                : state.isFocused
                    ? '#e5e7eb'
                    : document.documentElement.classList.contains('dark') ? '#1f2937' : '#ffffff',
            color: state.isSelected
                ? '#ffffff'
                : document.documentElement.classList.contains('dark') ? '#ffffff' : '#111827',
            '&:hover': { backgroundColor: state.isSelected ? '#3b82f6' : '#e5e7eb' },
        }),
        singleValue: (base) => ({
            ...base,
            fontSize: '0.875rem',
            color: document.documentElement.classList.contains('dark') ? '#ffffff' : '#111827',
        }),
        input: (base) => ({
            ...base,
            fontSize: '0.875rem',
            color: document.documentElement.classList.contains('dark') ? '#ffffff' : '#111827',
        }),
        placeholder: (base) => ({ ...base, fontSize: '0.875rem', color: '#9ca3af' }),
    };

    // ---- Criterio de año / Año / Gestión ----
    const selectedYears = Array.isArray(filters.years) ? filters.years : [];
    const selectedGestiones = Array.isArray(filters.gestiones) ? filters.gestiones : [];
    const selectedYearOptions = yearOptions.filter((o) => selectedYears.includes(o.value));
    const selectedGestionOptions = gestionOptions.filter((o) => selectedGestiones.includes(o.value));

    const handleYearsChange = (selected) => {
        const valores = (selected || []).map((o) => o.value);
        onFilterChange('years', valores);
        // La gestión se marca sola cuando están todos sus años elegidos.
        const gestiones = GESTIONES
            .filter((g) => valores.length > 0 && g.years.every((y) => valores.includes(y)))
            .map((g) => g.key);
        onFilterChange('gestiones', gestiones);
    };

    const handleGestionChange = (selected) => {
        const keys = (selected || []).map((o) => o.value);
        onFilterChange('gestiones', keys);
        if (keys.length === 0) {
            onFilterChange('years', []);
            return;
        }
        const elegidas = GESTIONES.filter((g) => keys.includes(g.key));
        const years = [...new Set(elegidas.flatMap((g) => g.years))]
            .sort((a, b) => String(b).localeCompare(String(a)));
        onFilterChange('years', years);
    };

    return (
        <div className="mb-6 p-4 border border-gray-200 rounded-lg bg-white shadow-sm dark:bg-gray-800 dark:border-gray-700">
            <div className="flex justify-between items-center mb-4">
                <div className="flex items-center">
                    <h2 className="text-lg font-semibold text-gray-800 dark:text-white">Filtros de Informes</h2>
                </div>
                <Button
                    onClick={limpiarFiltros}
                    className="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-white rounded-md transition-colors"
                >
                    Limpiar filtros
                </Button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 py-4">
                {/* Criterio de año */}
                <div>
                    <label htmlFor="criterioYear" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Criterio de año
                    </label>
                    <Select
                        id="criterioYear"
                        name="criterioYear"
                        value={CRITERIOS_ANIO.find((c) => c.value === filters.criterioYear) || CRITERIOS_ANIO[0]}
                        onChange={(selected) => onFilterChange('criterioYear', selected?.value || 'pago_anticipo')}
                        options={CRITERIOS_ANIO}
                        isSearchable={false}
                        isClearable={false}
                        styles={customSelectStyles}
                    />
                </div>

                {/* Año (múltiple) */}
                <div>
                    <label htmlFor="years" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Año
                    </label>
                    <Select
                        id="years"
                        name="years"
                        isMulti
                        options={yearOptions}
                        value={selectedYearOptions}
                        onChange={handleYearsChange}
                        isClearable
                        placeholder="Todos los años..."
                        closeMenuOnSelect={false}
                        styles={customSelectStyles}
                    />
                </div>

                {/* Gestión (múltiple) */}
                <div>
                    <label htmlFor="gestiones" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Gestión
                    </label>
                    <Select
                        id="gestiones"
                        name="gestiones"
                        isMulti
                        options={gestionOptions}
                        value={selectedGestionOptions}
                        onChange={handleGestionChange}
                        isClearable
                        placeholder="Todas las gestiones..."
                        closeMenuOnSelect={false}
                        styles={customSelectStyles}
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 py-4">
                {/* Filtro por Encargado */}
                <div>
                    <label htmlFor="encargado_proyecto" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Responsable
                    </label>
                    <Select_simple
                        id="encargado_proyecto"
                        name="encargado_proyecto"
                        value={filters.encargado_proyecto}
                        onChange={(e) => onFilterChange('encargado_proyecto', e.target.value)}
                        options={optionsEncargadoProyecto}
                        placeholder="Todos los responsables"
                    />
                </div>
                {/* Filtro por Objeto 
                <div>
                    <label htmlFor="objeto" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Objeto
                    </label>
                    <Select_simple
                        name="objeto"
                        value={filters.objeto}
                        onChange={(e) => onFilterChange('objeto', e.target.value)}
                        options={optionsObjeto_Tramitacion_Pagos}
                        placeholder="Todos los trámites por objeto"
                    />
                </div>
                */}

                {/* Filtro por Partido */}
                <div>
                    <div className="flex items-center">
                        <label htmlFor="partido_nombre" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Partido
                        </label>                        
                    </div>                
                    <Select_simple
                        id="partido_nombre"
                        name="partido_nombre"
                        value={filters.partido_nombre}
                        onChange={(e) => onFilterChange('partido_nombre', e.target.value)}
                        options={optionsPartido}
                        placeholder="Todos los partidos"
                    />                    
                </div>

                {/* Filtro por Organismo Solicitante Unicos */}
                <div>
                    <div className="flex items-center">
                        <label htmlFor="organismo_solicitante" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Municipio / ONGs
                        </label>
                        <InfoButtonWithPopover infoText="Solo se muestran los Municipios / ONGs donde hay proyectos" />
                    </div>
                    <Select
                        id="ong"
                        name="ong"
                        value={organismosSolicitanteUnicos.flatMap(grupo => grupo.options).find(option => option.value === filters.ong) || null}
                        onChange={(selected) => onFilterChange('ong', selected ? selected.value : '')}
                        options={organismosSolicitanteUnicos}
                        placeholder="Todos los Municipios / ONGs"
                        isSearchable
                        isClearable
                        noOptionsMessage={() => 'Sin resultados'}
                        styles={customSelectStyles}
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 py-4">
                {/* Filtro por Area Responsable */}
                <div>
                    <label htmlFor="area_responsable" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Área Responsable
                    </label>
                    <Select_simple
                        id="area_responsable"
                        name="area_responsable"
                        value={filters.area_responsable}
                        onChange={(e) => onFilterChange('area_responsable', e.target.value)}
                        options={optionsAreaResponsable}
                        placeholder="Todas los áreas responsables"
                    //className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />
                </div>

                {/* Filtro por Tipo (depende del área responsable) */}
                <div>
                    <label htmlFor="tipo" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Tipo
                    </label>
                    <Select_simple
                        id="tipo"
                        name="tipo"
                        value={filters.tipo}
                        onChange={(e) => onFilterChange('tipo', e.target.value)}
                        options={tiposUnicos}
                        placeholder="Todos los tipos"
                        disabled={!filters.area_responsable}
                    />
                </div>

                {/* Filtro por Subtipo (depende del tipo) */}
                <div>
                    <label htmlFor="subtipo" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Subtipo
                    </label>
                    <Select_simple
                        id="subtipo"
                        name="subtipo"
                        value={filters.subtipo}
                        onChange={(e) => onFilterChange('subtipo', e.target.value)}
                        options={subtiposUnicos}
                        placeholder="Todos los subtipos"
                        disabled={!filters.tipo}
                    />
                </div>

                {/* Filtro por Tipo Subsidio */}
                <div>
                    <label htmlFor="tipo_subsidio" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Tipo Subsidio
                    </label>
                    <Select_simple
                        id="tipo_subsidio"
                        name="tipo_subsidio"
                        value={filters.tipo_subsidio}
                        onChange={(e) => onFilterChange('tipo_subsidio', e.target.value)}
                        options={optionsTipoSubsidio}
                        placeholder="Todos los tipos de subsidio"
                    //className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />
                </div>

                {/* Categoría de la ONG. Solo tiene sentido cuando el subsidio es a una ONG.
                    Se muestran las 6 categorías de optionsCategoria (social, política, educativa,
                    religiosa, deportiva, sindical), las mismas que usan los informes de ONGs. */}
                {filters.tipo_subsidio === 'Subsidio a ONG' && (
                    <div>
                        <label htmlFor="categoria" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Categoría ONG
                        </label>
                        <Select_simple
                            id="categoria"
                            name="categoria"
                            value={filters.categoria}
                            onChange={(e) => onFilterChange('categoria', e.target.value)}
                            options={optionsCategoria}
                            placeholder="Todas las categorías"
                        />
                    </div>
                )}
                {/* Filtro por Programa - si no hay filter.area_responsable, mostrar select disabled*/}
                {!filters.area_responsable && (
                    <div>
                    <label htmlFor="programa" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Programa
                    </label>
                    <Select_simple
                        disabled
                        id="programa"
                        name="programa_lineamiento"
                        value={filters.programa_lineamiento}
                        onChange={(e) => onFilterChange('programa_lineamiento', e.target.value)}
                        options={optionsPrograma}
                        placeholder="Todos los programas"
                    //className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />
                </div>
                )}
                {/* Filtro por Programa según el área responsable */}
                {/* Filtro por Programa dinámico según el área responsable */}
                {PROGRAM_OPTIONS_MAP[filters.area_responsable] && (
                    <div>
                        <label htmlFor="programa" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Programa
                        </label>
                        <Select_simple
                            id="programa"
                            name="programa_lineamiento"
                            value={filters.programa_lineamiento}
                            onChange={(e) => onFilterChange('programa_lineamiento', e.target.value)}
                            options={PROGRAM_OPTIONS_MAP[filters.area_responsable]}
                            placeholder="Seleccionar..."
                        />
                    </div>
                )}

                {/* Filtro por Estado (junto a Programa) */}
                <div>
                    <label htmlFor="estado" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Estado
                    </label>
                    <Select_simple
                        id="estado"
                        name="estado"
                        value={filters.estado}
                        onChange={(e) => onFilterChange('estado', e.target.value)}
                        options={optionsEstado}
                        placeholder="Todos los estados"
                    //className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />
                </div>
                
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">

                {/* Búsqueda general */}
                <div>
                    <label htmlFor="search" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Buscar
                    </label>
                    <div className="relative">
                        {/* Ojo: al Input del ui/ pasarle className hace que se PIERDA la clase base
                        (input.jsx:8 la define antes del ...props), asi que esta lista tiene que
                        repetir a mano lo que la base le daba. Se copio la de select_simple para que
                        el input de busqueda se vea igual que los selects de al lado: faltaban
                        text-sm (por eso el texto iba a 16px en vez de 14), focus:outline-none, y
                        el fondo era gray-700 en vez de gray-800. El pl-10 es para el icono de la
                        lupa y el shadow-sm se saco porque los selects no lo tienen. */}
                        <Input
                            type="text"
                            id="search"
                            name="search"
                            value={filters.searchQuery}
                            onChange={(e) => onFilterChange('searchQuery', e.target.value)}
                            placeholder="Buscar por Id, Nombre de la obra o Expediente del proyecto..."
                            className="w-full pl-10 pr-4 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700"
                        />
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FiltrosInformes;
